import {Component, Input, OnInit,} from '@angular/core';
import {MvsSearchFlexibleBaseComponent} from "../../mvs-search-flexible-base.component";
import {MvsSearchFlexibleResultData} from "../../mvs-search-flexible-result.data";
import {FormBuilder, FormGroup} from "@angular/forms";
import {WidgetData} from "../../../widget/widget-data";
import {MvsCrudService} from "../../../service/crud/mvs-crud.service";
import {MvsFormDto} from "../../../dto/form/dto/mvs-form.dto";
import {MvsCoreService} from "../../../service/mvs-core.service";
import {FilterCriteria} from "../../../filter/api/filter.criteria";
import {ObjectRequestList} from "../../../dto/object/request/object-request-list";
import {Sorting} from "../../../misc/sorting";
import {PagingDto} from "../../../dto/model/paging.dto";
import {DtoTemplate} from "../../../dto/dto-template";
import {ObjectIdentifierData} from "../../../basic/object-identifier-data";
import {ObjectIdentifier} from "../../../basic/object-identifier";

@Component({
    selector: 'search-flexible-generic',
    templateUrl: './search-flexible-generic.component.html',
    standalone: false
})
export class SearchFlexibleGenericComponent
    extends MvsSearchFlexibleBaseComponent
    implements OnInit {

  @Input() displayInDialog: boolean;

    widgetData: WidgetData;

    crudService: MvsCrudService;

    formObjectType: string;
    formDto: MvsFormDto;

    showSearchId: boolean;
    showSearchName: boolean;
    showSearchAlias: boolean;
    searchForm: FormGroup;

    constructor(protected coreService: MvsCoreService, private fb: FormBuilder) {
        super();
        this.searchForm = this.fb.group({
            searchId: [''],
            searchName: [''],
            searchAlias: ['']
        });
    }

    ngOnInit() {

        // get service
        this.crudService = this.coreService.getCrudService(this.objectType);

        // retrieve form
        this.refreshComponent();

    }

    onSearch() {
        this.refreshWidget();
    }

    /**
     * Refresh widget.
     */
    refreshWidget() {

        const formValues = this.searchForm.value;

        const widgetData = new WidgetData();
        widgetData.idAlias = 'cr.search.flexible.generic.' + this.objectType;
        widgetData.name = 'Generic';
        widgetData.uiComponent = 'table';
        widgetData.dataProvider = 'list';
        widgetData.dataSource = 'entity';
        widgetData.dataProviderObject = this.objectType;

        this.widgetData = null;


        const filterCriteria: FilterCriteria[] = [];

        if (this.showSearchId && formValues.searchId) {
            filterCriteria.push(
                FilterCriteria.create('id', FilterCriteria.cOperatorEqual, formValues.searchId, null)
            );
        }

        if (this.showSearchAlias && formValues.searchAlias) {
            filterCriteria.push(
                FilterCriteria.create('alias', FilterCriteria.cOperatorContainsPattern, '%' + formValues.searchAlias + '%', null)
            );
        }

        if (this.showSearchName && formValues.searchName) {
            filterCriteria.push(
                FilterCriteria.create('name', FilterCriteria.cOperatorContainsPattern, '%' + formValues.searchName + '%', null)
            );
        }

        if (filterCriteria.length > 0) {

            widgetData.dataProviderListRequest =
                ObjectRequestList.createWithPaging(
                    true,
                    filterCriteria,
                    [new Sorting('createdDate', false)],
                    PagingDto.create(0, 10)
                );

            widgetData.setParamValue("selectionMode", "rowSelect");
            widgetData.setParamValue("rowSelectionMode", "sticky");
            widgetData.setParamValue('size', 'S');

            this.widgetData = widgetData;
          // this.createWidgetComponent();

        }

        this.onSearchAction.emit(formValues);

        this.initialized = true;

    }

    /**
     * Reset the search.
     * @protected
     */
    protected resetSearch() {

        // remove widget table
        this.widgetData = null;

        this.showSearchId = false;
        this.showSearchName = false;
        this.showSearchAlias = false;

        this.showSearchId = null;
        this.showSearchAlias = null;
        this.showSearchName = null;
    }

    /**
     * Refresh component by retrieving the form information.
     */
    override refreshComponent() {

        this.resetSearch();

        if (this.formObjectType == this.objectType) {
            this.refreshWidget(); // refresh the widget
        }

        this.crudService.template(new DtoTemplate()).subscribe(value => {
            this.formObjectType = this.objectType;
            this.formDto = value;

            if (this.formDto.formFields["id"]) {
                this.showSearchId = true;
            }

            if (this.formDto.formFields["alias"]) {
                this.showSearchAlias = true;
            }

            if (this.formDto.formFields["name"]) {
                this.showSearchName = true;
            }


            this.refreshWidget();
        });


    }

    deriveLabelFromData(e: ObjectIdentifierData | ObjectIdentifier): string {

        let event = e as ObjectIdentifierData;

        if (this.showSearchName) {
            return event.data["name"];
        }

        if (this.showSearchAlias) {
            return event.data["alias"];
        }

        if (this.showSearchId) {
            return event.data["id"];
        }

        return event.data[0];

    }


    handleObjectSelect(event: ObjectIdentifierData | ObjectIdentifier) {

        const result: MvsSearchFlexibleResultData =
            MvsSearchFlexibleResultData.create(event as ObjectIdentifierData, this.deriveLabelFromData(event));

        this.onObjectSelect.emit(result);
    }

}
